import React, { useEffect, useState } from 'react';
import { Modal, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import SymbolAvgVoltage from './SymbolAvgVoltage';
import "./Svg.css";


function SvgPVInverter({x, y, Combinations }) {
    const { t } = useTranslation();

    const [count, setCount] = useState(0);
    const [PPVInverter, setPPVInverter] = useState(0);
    const [VPVInverter, setVPVInverter] = useState(0);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        if (Combinations != null) {
            let rs = [];
            let pInv = 0;
            let vInv = 0;
            let vInvCount = 0;
            Combinations.forEach((item) => {
                let ppvInv = "";
                if (item.PPVInverter != null) {
                    let v = parseInt(item.PPVInverter);
                    if (v > 0x7fffffff) {
                        v = v - 0x100000000;
                    }
                    pInv += v * 0.001;
                    ppvInv = (v * 0.001).toFixed(3);
                }
                let qpvInv = "";
                if (item.QPVInverter != null) {
                    let v = parseInt(item.QPVInverter);
                    if (v > 0x7fffffff) {
                        v = v - 0x100000000;
                    }
                    qpvInv = (v * 0.001).toFixed(3);
                }
                let ipvInv = "";
                if (item.IPVInverter != null) {
                    let v = parseInt(item.IPVInverter);
                    if (v > 0x7fff) {
                        v = v - 0x10000;
                    }
                    ipvInv = (v * 0.1).toFixed(1);
                }
                if (item.VPVInverter != null) {
                    vInv += parseInt(item.VPVInverter) * 0.1;
                    vInvCount++;
                }
                rs.push({
                    SN: item.SN,
                    CreateTime: item.CreateTime,
                    Phase: item.InverterConnectionMode,
                    PPVInverter: ppvInv,
                    QPVInverter: qpvInv,
                    VPVInverter: item.VPVInverter != null ? (parseInt(item.VPVInverter) * 0.1).toFixed(1) : "",
                    IPVInverter: ipvInv,
                });
            });
            setPPVInverter(pInv.toFixed(3));
            setVPVInverter((vInvCount > 0 ? vInv / vInvCount : 0).toFixed(1));
            setRows(rs);
            setCount(Combinations.length);
        }
    }, [Combinations]);

    const handleClick = () => {
        Modal.info({
            maskClosable: true,
            width: "80%",
            icon: null,
            title: t("PVInverter Data"),
            content: (<Table 
                pagination={false}
                columns={[
                    { title: t("Inverter SN"), dataIndex: "SN",  align: "right",render: (v,r) => {
                        return `${v}${r.Phase === 2 ? "(A)" : r.Phase === 3 ? "(B)" : r.Phase === 4 ? "(C)" : ""}`;
                    } },
                    { title: t("DataTime"), dataIndex: "CreateTime",  align: "right" },
                    { title: t("PPVInverter")+"(kW)", dataIndex: "PPVInverter",  align: "right" },
                    { title: t("QPVInverter")+"(kW)", dataIndex: "QPVInverter",  align: "right" },
                    { title: t("VPVInverter")+"(V)", dataIndex: "VPVInverter",  align: "right" },
                    { title: t("IPVInverter")+"(A)", dataIndex: "IPVInverter",  align: "right" },
                ]}
                dataSource={rows}
                scroll={{ x: true }}
            />),
            onOk() {
            },
        });
    };

    const textW = 220;

    return (<svg xmlns="http://www.w3.org/2000/svg">
        <svg cursor={"pointer"} x={x} y={y} width={64} height={64}  viewBox="0 0 1024 1024"
            onClick={handleClick}
        >
            <SymbolAvgVoltage id="VoltageAvg-PVInv"/>

            <defs>
                <style>{`.cls-1{fill:#1d80b5;}`}</style>
            </defs>
            <rect x="0" y="0" width="1024" height="1024" fill="#fff" stroke="none" />
            <path d="M948.224 165.888h-137.216V116.736c0-14.336-12.288-24.576-24.576-24.576h-100.352c-14.336 0-24.576 12.288-24.576 24.576v49.152H362.496V116.736c0-14.336-12.288-24.576-24.576-24.576h-100.352c-14.336 0-24.576 12.288-24.576 24.576v49.152H75.776c-40.96 0-75.776 32.768-75.776 75.776v616.448c0 40.96 32.768 75.776 75.776 75.776h874.496c40.96 0 75.776-32.768 75.776-75.776V241.664c-2.048-40.96-34.816-75.776-77.824-75.776z m14.336 669.696c0 18.432-14.336 32.768-32.768 32.768H94.208c-18.432 0-32.768-14.336-32.768-32.768V264.192c0-18.432 14.336-32.768 32.768-32.768h835.584c18.432 0 32.768 14.336 32.768 32.768v571.392z" p-id="1709" fill="#1d80b5"></path><path d="M888.832 696.32l-51.2-210.944-2.048-8.192c-8.192-22.528-30.72-36.864-55.296-36.864H552.96c-24.576 4.096-43.008 20.48-49.152 45.056L452.608 696.32l-2.048 8.192v6.144c0 16.384 6.144 30.72 16.384 43.008 10.24 10.24 26.624 18.432 43.008 18.432H675.84c-10.24 0-16.384 8.192-16.384 18.432v18.432h-36.864c-10.24 0-18.432 8.192-18.432 18.432s8.192 18.432 18.432 18.432h110.592c10.24 0 18.432-8.192 18.432-18.432s-8.192-18.432-18.432-18.432H696.32v-18.432c0-8.192-6.144-16.384-14.336-18.432h-4.096 159.744l6.144-2.048c14.336-4.096 28.672-14.336 36.864-26.624 10.24-14.336 12.288-30.72 8.192-47.104z m-55.296 28.672H505.856c-6.144-2.048-10.24-6.144-10.24-12.288v-4.096l51.2-210.944 2.048-4.096c2.048-4.096 6.144-6.144 12.288-6.144h219.136c6.144 0 12.288 4.096 14.336 10.24l51.2 210.944v4.096c-2.048 6.144-6.144 10.24-12.288 12.288z" p-id="1710" fill="#1d80b5"></path><path d="M786.432 589.824c8.192 0 18.432 6.144 22.528 16.384l2.048 6.144 16.384 73.728c2.048 14.336-2.048 26.624-12.288 28.672h-112.64c-10.24 0-20.48-10.24-22.528-22.528v-79.872c0-10.24 6.144-18.432 14.336-22.528h92.16zM645.12 589.824c10.24 0 16.384 6.144 18.432 16.384v79.872c0 14.336-8.192 26.624-18.432 28.672H532.48c-10.24 0-18.432-10.24-18.432-22.528v-6.144l16.384-73.728c2.048-10.24 10.24-18.432 18.432-22.528h96.256zM649.216 493.568c8.192 0 14.336 4.096 16.384 10.24v59.392c0 8.192-6.144 16.384-14.336 20.48h-96.256c-4.096 0-8.192-2.048-10.24-4.096s-4.096-6.144-4.096-10.24v-6.144l10.24-53.248c2.048-8.192 8.192-14.336 14.336-16.384h83.968zM768 493.568c8.192 0 14.336 4.096 18.432 10.24l2.048 6.144 10.24 53.248c2.048 10.24-2.048 16.384-10.24 20.48H696.32c-8.192 0-16.384-6.144-18.432-14.336v-59.392c0-8.192 4.096-14.336 12.288-16.384h77.824zM131.072 417.792h301.056v75.776H131.072zM131.072 299.008h301.056v75.776H131.072z" p-id="1711" fill="#1d80b5"></path>
            {count > 1 ?
                <svg x ={84 - 32} y={84 - 32} width="32" height="32" viewBox="0 0 100 100">
                    <circle cx="50" cy="50" r="46" stroke="#eee" strokeWidth="8" fill="#1d80b5" />
                    <text x="50" y="53" fontSize="46px" fill="white" fontWeight="bold" textAnchor="middle" alignmentBaseline="middle">∑</text>
                </svg>
                : null
            }
        </svg>
        <svg x={x - textW - 8} y={y + 8} width={textW} cursor={"pointer"} onClick={handleClick}>
            <text x={textW} y={20} fontSize="20" fill="black" textAnchor="end">{t("PV Inverter")}</text>
            <text x={textW} y={48} fontSize="20" fill="black" textAnchor="end">
                {PPVInverter} kW
                {count>1 && <tspan dy="-1.2em" className='sigma'>(Σ{count})</tspan>}
            </text>
            <text x={textW - (count>1 ? 0 : 24)} y={76} fontSize="20" fill="black" textAnchor="end">{VPVInverter}</text>
            {count<2 && <text x={textW} y={76} fontSize="20" fill="black" textAnchor="end">V</text>}
            {count>1 && <use href="#VoltageAvg-PVInv" x={textW - 24} y={56} fontSize="20" width="24" height="20" />}
        </svg>
    </svg>)
}

export default SvgPVInverter
